export var ProjectState;
(function (ProjectState) {
    ProjectState[ProjectState["FUNDRAISING"] = 0] = "FUNDRAISING";
    ProjectState[ProjectState["GRADUATED_PENDING_LP"] = 1] = "GRADUATED_PENDING_LP";
    ProjectState[ProjectState["ACTIVE"] = 2] = "ACTIVE";
    ProjectState[ProjectState["FAILED"] = 3] = "FAILED";
})(ProjectState || (ProjectState = {}));
export var LiquidityMode;
(function (LiquidityMode) {
    LiquidityMode[LiquidityMode["PROTOCOL_LOCKED_V2"] = 0] = "PROTOCOL_LOCKED_V2";
    LiquidityMode[LiquidityMode["CREATOR_MANAGED_V2"] = 1] = "CREATOR_MANAGED_V2";
})(LiquidityMode || (LiquidityMode = {}));
export var PaymentKind;
(function (PaymentKind) {
    PaymentKind[PaymentKind["NATIVE"] = 0] = "NATIVE";
    PaymentKind[PaymentKind["ERC20"] = 1] = "ERC20";
})(PaymentKind || (PaymentKind = {}));
export var VerificationStatus;
(function (VerificationStatus) {
    VerificationStatus[VerificationStatus["UNVERIFIED"] = 0] = "UNVERIFIED";
    VerificationStatus[VerificationStatus["VERIFIED"] = 1] = "VERIFIED";
})(VerificationStatus || (VerificationStatus = {}));
export var RewardPoolKind;
(function (RewardPoolKind) {
    RewardPoolKind[RewardPoolKind["UNVERIFIED"] = 0] = "UNVERIFIED";
    RewardPoolKind[RewardPoolKind["VERIFIED"] = 1] = "VERIFIED";
})(RewardPoolKind || (RewardPoolKind = {}));
export var AssetKind;
(function (AssetKind) {
    AssetKind[AssetKind["NAND"] = 0] = "NAND";
    AssetKind[AssetKind["MINER"] = 1] = "MINER";
})(AssetKind || (AssetKind = {}));
export var CreditKind;
(function (CreditKind) {
    CreditKind[CreditKind["REFUND"] = 0] = "REFUND";
    CreditKind[CreditKind["CREATOR_PROCEEDS"] = 1] = "CREATOR_PROCEEDS";
    CreditKind[CreditKind["MARKET_SELLER"] = 2] = "MARKET_SELLER";
    CreditKind[CreditKind["TREASURY"] = 3] = "TREASURY";
})(CreditKind || (CreditKind = {}));
export var ListingStatus;
(function (ListingStatus) {
    ListingStatus[ListingStatus["ACTIVE"] = 0] = "ACTIVE";
    ListingStatus[ListingStatus["CANCELLED"] = 1] = "CANCELLED";
    ListingStatus[ListingStatus["SOLD"] = 2] = "SOLD";
    ListingStatus[ListingStatus["INVALIDATED"] = 3] = "INVALIDATED";
})(ListingStatus || (ListingStatus = {}));
export var ListingPurchasability;
(function (ListingPurchasability) {
    ListingPurchasability[ListingPurchasability["PURCHASABLE"] = 0] = "PURCHASABLE";
    ListingPurchasability[ListingPurchasability["PROTOCOL_PAUSED"] = 1] = "PROTOCOL_PAUSED";
    ListingPurchasability[ListingPurchasability["PROJECT_NOT_ACTIVE"] = 2] = "PROJECT_NOT_ACTIVE";
    ListingPurchasability[ListingPurchasability["OWNER_CHANGED"] = 3] = "OWNER_CHANGED";
    ListingPurchasability[ListingPurchasability["AUTHORIZATION_CHANGED"] = 4] = "AUTHORIZATION_CHANGED";
    ListingPurchasability[ListingPurchasability["ASSET_INVALID"] = 5] = "ASSET_INVALID";
})(ListingPurchasability || (ListingPurchasability = {}));
export var ListingAuthorizationKind;
(function (ListingAuthorizationKind) {
    ListingAuthorizationKind[ListingAuthorizationKind["TOKEN_APPROVAL"] = 0] = "TOKEN_APPROVAL";
    ListingAuthorizationKind[ListingAuthorizationKind["OPERATOR_APPROVAL"] = 1] = "OPERATOR_APPROVAL";
})(ListingAuthorizationKind || (ListingAuthorizationKind = {}));
export var CommitStatus;
(function (CommitStatus) {
    CommitStatus[CommitStatus["ABSENT"] = 0] = "ABSENT";
    CommitStatus[CommitStatus["ACTIVE"] = 1] = "ACTIVE";
    CommitStatus[CommitStatus["USED"] = 2] = "USED";
    CommitStatus[CommitStatus["EXPIRED"] = 3] = "EXPIRED";
})(CommitStatus || (CommitStatus = {}));
export var MetadataNonceStatus;
(function (MetadataNonceStatus) {
    MetadataNonceStatus[MetadataNonceStatus["ISSUED"] = 0] = "ISSUED";
    MetadataNonceStatus[MetadataNonceStatus["CONSUMED"] = 1] = "CONSUMED";
    MetadataNonceStatus[MetadataNonceStatus["EXPIRED"] = 2] = "EXPIRED";
})(MetadataNonceStatus || (MetadataNonceStatus = {}));
const UINT256_MAX = (1n << 256n) - 1n;
function assertUint256(value, label) {
    if (value < 0n || value > UINT256_MAX) {
        throw new RangeError(`${label} must be an unsigned 256-bit integer`);
    }
}
export function tokenAmount(value) {
    assertUint256(value, "TokenAmount");
    return value;
}
export function nativeAmount(value) {
    assertUint256(value, "NativeAmount");
    return value;
}
export function chainId(value) {
    if (!Number.isSafeInteger(value) || value <= 0) {
        throw new RangeError("ChainId must be a positive safe integer");
    }
    return value;
}
//# sourceMappingURL=types.js.map